// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__3RZs9","marketplaceStroke":"IconEmailAttention_marketplaceStroke__1vAYW","attentionStroke":"IconEmailAttention_attentionStroke__sAI4w"};